import { render, staticRenderFns } from "./LicensesIndex.vue?vue&type=template&id=551537a6&"
import script from "./LicensesIndex.vue?vue&type=script&lang=js&"
export * from "./LicensesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports